import { Outlet } from 'react-router'

const SaleMainLayout = () => {
  return (
    <Outlet />
  )
}

export default SaleMainLayout